export default __webpack_public_path__ + "static/media/withdraw.427aa109.svg";